import React from 'react';
import AppHeader from '../../../../components/Header/Header';
import AppFooter from '../../../../components/Footer/footer';
import AppBlogOrganica from '../../../../components/blogOrganica';
import BannerSection from '../../../../components/BannerSection';
import SidebarMenu from '../../../../components/SidebarMenu';
import SectionHeading from '../../../../components/SectionHeading';
import BreadcrumbNav from '../../../../components/BreadcrumbNav';

const caminho = [
    { label: 'Home', href: '/', icon: 'bi bi-house-door' },
    { label: 'Unidade Orgânica', href: '/programas/unidade-organica' },
    { label: 'Ciências da Saúde', href: '/programas/unidade_organica/ciencia_saude' },
    { label: 'Apresentação' }
];

function ApresentacaoCS() {
    return (
        <>
            <header id='header'>
                <AppHeader />
            </header>
            <BannerSection
                title="Unidade Orgânica de Ciências da Saúde"
                subtitle="Bem-vindo à Unidade Orgânica de Ciências da Saúde"
                description={`Descubra um ambiente de aprendizado inovador, onde a excelência acadêmica e a prática clínica se encontram para formar profissionais de saúde altamente qualificados.`}
                backgroundImage={require('../../../../assets/UN_OR_01.jpg')}
                backgroundId="instituition-Banner"
            />
             <BreadcrumbNav items={caminho} />
            <main className="px-3 px-md-5 px-xl-5 px-xxl-5 py-2">
                <br />
                <div className="row flex-row-reverse">
                     <div className="col-12 col-md-4 col-lg-3 col-xl-2">
                        <SidebarMenu
                            title="Programas"
                            items={[
                            { label: "Apresentação", href: "/programas/unidade-organica/ciencia-saude" },
                            { label: "Missão Visão e Valores", href: "/programas/unidade-organica/ciencia-saude/missao-visao-valores" },
                            { label: "Docentes", href: "/programas/unidade-organica/ciencia-saude/docentes" },
                            ]}
                        />
                        </div>
                    <div className="col-12 col-md-8 col-lg-9 col-xl-10 col-xxl-10">
                        <br />
                        <div style={{ marginLeft: '50px' }} className="details-magazine">

                            <p className="f-reg">
                                 <SectionHeading title="Breve Historial" />
                                <br />
                                Unidade Orgânica, tendo os seus cursos devidamente legalizados através do Decreto Executivo n.º 433/12, de 24 de Outubro, fundado desde 2013, pela entidade promotora Instituto Superior Politécnico Atlântida, cujo na idoneidade na vertente de ensino desde 2003. Representado pela Dra.
                                Soqui Isabel Mendes, licenciada em Ciências da Saúde.
                                <br /><br />  Em 2013 arrancou o ano académico com mais de 800 alunos, 3 cursos e 65 professores, 27 salas de aulas. Sendo que em 2018 foram outorgados mais de 100 estudantes da primeira promoção, 2018  e em 2021 mais de 200 estudantes, quadros de alta qualificação, esperando que os mesmos façam a diferença no mercado nacional e Internacional gerando e difundindo conhecimentos, preservando e divulgando valores para a transformação das sociedades. Atualmente, a Unidade orgânica da Saúde possui um Centro Médico Atlântida para a conciliação da teoria e prática aos estudantes e professores dos cursos ministrados.
                            </p>
                            <br />
                            <p className="f-reg">
                            <SectionHeading title="Inserção Regional" />
                            A Unidade Ôrganica de Ciências da Saúde está nas instalações sede do Instituto Superior Politécnico Atlântida, localizada na Provincia de Luanda, município do Talatona na estrada direita do Patriota-Benfica.
                            <br />
                            </p>
                            <br />

                            <p className="f-reg">
                            <SectionHeading title="Responsabilidade Social" />
                             Dada a localização regional e culminando com a visão da unidade ôrganica da saúde em ser uma unidade com o espírito altruísta ajudando as pessoas mais vulneráveis da sociedade, a responsabilidade social está focada aos seguintes programas: 
                            <br />
                            </p>

                        </div>
                        <AppBlogOrganica />
                    </div>
                </div>
                <br />
                <br />
                <br />
                <br />
                <br />
            </main>
            <footer id="footer">
                <AppFooter />
            </footer>
        </>
    );
}

export default ApresentacaoCS;
